import React, { useState, useEffect, useContext } from 'react'
import { observer } from 'mobx-react-lite'
import { Dot } from 'react-bootstrap-icons'
import FoldersListItem from './FoldersListItem'
import SortByDropdown from './SortByDropdown'
import ShowMoreBtn from './ShowMoreBtn'
import { useParams } from 'react-router-dom'
import { BrowseContext } from '../../../contexts/BrowseContext'

export default observer(function FoldersList() {
  const { browseState, folders, folderListSort } = useContext(BrowseContext)
  const { client_id } = useParams()
  const [showMore, setShowMore] = useState(false)

  return (
    <div className='px-8 pb-8'>
      <div className='flex items-center justify-between'>
        <div className='flex items-center'>
          <h2 className='font-bold text-lg dark:text-white'>{ client_id ? "Folders" : "Recent folders"}</h2>
          <Dot className='h-7 w-7 rb-text-muted' />
          <span className='font-bold text-lg rb-text-muted'>{folders.length}</span>
        </div>
        <SortByDropdown
          sortDirection={folderListSort.direction}
          editSortDirection={() => folderListSort.direction === 'desc' ? folderListSort.direction = 'asc' : folderListSort.direction = 'desc'}
          editSortAttribute={option => folderListSort.attribute = option}
        />
      </div>

      <div className="grid grid-cols-3 gap-5 mt-3">
        <button
          className='bg-gray-100 dark:bg-rb-dark-mode rounded-lg border-dashed border-2 border-rb-dash-border dark:border-rb-dark-mode-lighter h-20 font-bold dark:text-white'
          onClick={() => browseState.toggleCreateFolder() }
        >
          Create folder
        </button>
        {
          showMore ? (
            folders.map(folder => <FoldersListItem key={folder.id} folder={folder} />)
          ) : (
            folders.slice(0, client_id ? 5 : 8).map(folder => <FoldersListItem key={folder.id} folder={folder} />)
          )
        }
      </div>
      <div className="flex justify-end pt-3">
        <ShowMoreBtn showMore={showMore} handleClick={() => setShowMore(!showMore)} />
      </div>
    </div>
  )
})
